import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import axios from "axios";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TablePagination from "@mui/material/TablePagination";
import { formatDate } from "../utils/helper";
import excelIcon from "../Assets/images/excel.png";
import closeIcon from "../Assets/images/close_icon.png";
import baseURL from '../config'
import ShowSnackBar from "../components/snackBar";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EuroIcon from '@mui/icons-material/Euro';
import { useUIContext } from "../context/index";
import { apiCall } from "../services/authServieces";

function Row({ row, onSubmit, index, isOpen, toggleRow }) {
  const { userType,userRights } = useUIContext();
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [walletAction, setWalletAction] = useState("Add");
  const [walletAmount, setWalletAmount] = useState("");
  const [walletRemarks, setWalletRemarks] = useState("");
  const [errors, setErrors] = useState("");
  const [historyData, setHistoryData] = useState([]);
  const [snackBar, setSnackBar] = useState({
    open: false,
    open: false,
    severity: "success",
    message: "",
  });

  console.log(userRights,'userright')

  const handleCloseSnackBar = (event, reason) => {
    setSnackBar((prevState) => ({ ...prevState, open: false }));
  };

  const handleOpen = () => setOpenModal(true);
  const handleClose = () => {
    setWalletAction("Add");
    setWalletAmount("");
    setWalletRemarks("");
    setErrors({});
    setOpenModal(false);
  };
 
  const validateForm = () => {
    let formErrors = {};

    if (walletAmount.trim() === "") {
      formErrors.amount = "Amount is required.";
    }

    if (walletRemarks.trim() === "") {
      formErrors.remarks = "Remarks is required";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }
    onSubmit(walletAction, walletAmount, row.user_id, walletRemarks, row.balanceId, row.adminId);
    handleClose();
  };

  const showTransactionDetails = async (rowData) => {
    try{
      // setOpen(!open)
      toggleRow(); 
      
      if(!isOpen){
        const endpoint = `api/transaction/get-transaction/${rowData.adminId}/${rowData.user_id}`
        let response = await apiCall({
          endpoint: endpoint,
          method: "GET",
        });

        if (response?.success){
          setHistoryData(response?.data);
        }
      }
    }catch(error){
      console.log("Error on loading data: ", error)
      setSnackBar({
        open: true,
        severity: false,
        message: 'Internal Server Error'
      })
    }
  }
 
  const [selectedCurrency, setSelectedCurrency] = useState("");  // Track selected currency

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        {/* <TableCell>
        </TableCell> */}
        <TableCell
          align="right"
          className="position-relative"
          style={{ paddingLeft: "25px" }}
        >
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => showTransactionDetails(row)}
            className="DropBtn"
            style={{ position: "absolute", left: 0, top: 0 }}
          >
            {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
          <span>{row.user_id}</span>
        </TableCell>
        <TableCell align="right">{row.user_name}</TableCell>
        <TableCell align="right">{row.region}</TableCell>
        <TableCell align="right">
          {row?.balance ? parseFloat(row.balance).toFixed(3) : "N/A"}
        </TableCell>
        {userType === "super_admin" && userRights.transactionsWrite && (
          <TableCell align="right">
          <button onClick={handleOpen} className="eyeBtn">
            {row.currency_type === "Rupees" ? (
              <CurrencyRupeeIcon style={{ fontSize: 20 }} />
            ) : (
              <>ADD</>
            )}

            {/* <p>{row.currency_type}</p> */}
            {/* <CurrencyRupeeIcon /> */}
          </button>
          </TableCell>
        )}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <>
              <Box sx={{ marginTop: 1 }}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell align="right" colSpan={3}>
                        Activation Date : <span>{row.activationDate}</span>
                      </TableCell>
                      <TableCell>State : <span>{row.state ?? "N/A"}</span></TableCell>
                      <TableCell>
                        City : <span>{row.city ?? "N/A"}</span>
                      </TableCell>
                      {/* <TableCell>
                        Region : <span>{row.region ?? "N/A"}</span>
                      </TableCell> */}
                    </TableRow>
                  </TableHead>
                </Table>
              </Box>

              <Box>
                {/* <Typography variant="h6" gutterBottom component="div">
                  History
                </Typography> */}
                <Table size="small" aria-label="purchases" className="HTable decreaseMargin">
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell align="right">Amount</TableCell>
                      <TableCell align="right">Previous Balance</TableCell>
                      {userType === "super_admin" &&( <TableCell align="right">Admin ID</TableCell>
                    )}
                      <TableCell align="right">Transaction Type</TableCell>
                      <TableCell align="right">Remarks</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {historyData && historyData.length > 0 ? (
                      historyData.map((historyRow, index) => (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell>{historyRow?.transactionDate}</TableCell>
                            <TableCell align="right">
                              {parseFloat(historyRow.amount).toFixed(3)}
                            </TableCell>
                            <TableCell align="right">
                              {!isNaN(parseFloat(historyRow.previousBalance)) 
                                ? parseFloat(historyRow.previousBalance).toFixed(3) 
                              : "-"}
                            </TableCell>

                            {userType === "super_admin" && (
                           <TableCell align="right">
                              {historyRow.adminId}
                            </TableCell> 

                                              )} 
                            <TableCell align="right">{historyRow.type}</TableCell>
                            <TableCell align="right">
                              <textarea
                                name="remarks"
                                id="hremarks"
                                className="TableRemarks"
                                readOnly
                                value={historyRow.remarks}
                              />
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No data available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            </>
          </Collapse>
        </TableCell>
      </TableRow>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box className="ModalBox">
          <h2 className="WalletTitle">
            Wallet{" "}
            <button className="CloseBtn" onClick={handleClose}>
              <img src={closeIcon} alt="img" />
            </button>
          </h2>
          <Box className="WalletContain">
            <h5>
              Dealer Code: <span className="UserID">{row.user_id}</span>
            </h5>
            <div className="Devider"></div>
            <div className="WalletSelect">
              <select
                name="Add"
                id="add"
                value={walletAction}
                onChange={(e) => setWalletAction(e.target.value)}
              >
                <option value="Add">Add</option>
                <option value="Deduct">Deduct</option>
              </select>

            </div>
            <div className="Devider"></div>


            {/* Currency Type Selection */}
            {/* <div className="Currencytype">
              <label>Currency  <span style={{ color: "red", fontSize: "12px" }}>
                *
              </span></label>
              {row.currency_type ? (
                // Display the currency type as a non-editable field
                <Typography>{row.currency_type}</Typography>
              ) : (
                // If no currency type exists, show the dropdown
                // <select value={selectedCurrency} onChange={handleCurrencyChange}>
                //   <option value="">---Select Currency Type ---</option>
                //   <option value="Rupees">Rupees</option>
                //   <option value="Euro">Euro</option>
                //   <option value="Dollar">Dollar</option>
                // </select>
                <div className="WalletSelect">
                  <select

                    value={selectedCurrency} onChange={handleCurrencyChange}
                  >
                    <option value="">---Select Currency Type ---</option>
                    <option value="Rupees">Rupees</option>
                    <option value="Euro">Euro</option>
                    <option value="Dollar">Dollar</option>
                  </select>

                </div>
              )}

              {errors.currency && (
                <Typography color="error" className="ErrorMsg">
                  {errors.currency}
                </Typography>
              )}
            </div> */}


            {/* <div className="Devider"></div> */}

            <div className="WalletAmount">
              <span style={{ position: "relative" }} className="d-inline-block">
                Balance{" "}
                <span style={{ color: "red" }} className="RequiredStar">
                  *
                </span>
              </span>
              {/* Render the selected currency icon */}
              {row.currency_type ? (
                row.currency_type === "Euro" ? (
                  <EuroIcon style={{ fontSize: 20 }} />
                ) : row.currency_type === "Dollar" ? (
                  <AttachMoneyIcon style={{ fontSize: 20 }} />
                ) : row.currency_type === "Rupees" ? (
                  <CurrencyRupeeIcon style={{ fontSize: 20 }} />
                ) : null
              ) : (
                selectedCurrency === "Euro" ? (
                  <EuroIcon style={{ fontSize: 20 }} />
                ) : selectedCurrency === "Dollar" ? (
                  <AttachMoneyIcon style={{ fontSize: 20 }} />
                ) : selectedCurrency === "Rupees" ? (
                  <CurrencyRupeeIcon style={{ fontSize: 20 }} />
                ) : null
              )}

             <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={walletAmount}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || /^\d*\.?\d*$/.test(value)) {
                  setWalletAmount(value);
                }
              }}
              // onKeyDown={(e) => {
              //   if (
              //     ["e", "E", "+", "-", ","].includes(e.key)
              //   ) {
              //     e.preventDefault();
              //   }
              // }}
            />
              {errors.amount && (
                <Typography color="error" className="Errormsg">
                  {errors.amount}
                </Typography>
              )}
            </div>
            <div className="Devider"></div>
            <div className="WalletRemarks">
              <textarea
                name="remarks"
                id="remarks"
                value={walletRemarks}
                onChange={(e) => setWalletRemarks(e.target.value)}
                placeholder="Write your Remarks"
              ></textarea>
              {errors.remarks && (
                <Typography color="error" className="Errormsg">
                  {errors.remarks}
                </Typography>
              )}
            </div>
            <div className="Devider"></div>

            <div className="WalletBtns">
              <Button variant="contained" onClick={handleSubmit}>
                Proceed
              </Button>
            </div>
          </Box>
        </Box>
      </Modal>

      <ShowSnackBar
        open={snackBar.open}
        severity={snackBar.severity}
        message={snackBar.message}
        onClose={handleCloseSnackBar}
      />
    </React.Fragment>
  );
}

export default function CollapsibleTable({
  rows,
  totalRows,
  onSubmit,
  fetchTransactions,
  collapseTable,
  setCollapseTable,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
   const { userType,userRights } = useUIContext();
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchTransactions(newPage + 1, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    fetchTransactions(1, parseInt(event.target.value, 10));
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table" className="Table">
        <TableHead>
          <TableRow>
            {/* <TableCell /> */}
            <TableCell align="right">Dealer Code</TableCell>
            <TableCell align="right">Dealer Name</TableCell>
            <TableCell align="right">Region</TableCell>
            <TableCell align="right">Wallet</TableCell>
            {userType === "super_admin" && userRights.transactionsWrite && (
              <TableCell align="right">Add</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <Row key={row.id} row={row} onSubmit={onSubmit} index={index}
              isOpen={collapseTable === row.user_id} // OR use `row.id` if that's unique
              toggleRow={() =>
                setCollapseTable(collapseTable === row.user_id ? null : row.user_id)
              }
            />
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={totalRows}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}

CollapsibleTable.propTypes = {
  rows: PropTypes.array.isRequired,
  totalRows: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fetchTransactions: PropTypes.func.isRequired,
};
